import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser, selectUser, setCustomerCode } from "../../ReduxStore/userReducer";
// import { resetItemGroup, resetItems } from "../../ReduxStore/itemReducer";
import SearchIcon from '@mui/icons-material/Search';
import { resetCustomerDetails, resetItemGroup, resetItems } from "../../ReduxStore/actions";
import "./header.css"
import { useOutsideAlerter } from "../dropdownCloser/dropdownCloser";
import axios from "axios";
import { removeItemInTable, SapDisconnection } from "../../API/API";
import { fetchCart } from "../../ReduxStore/reduxThunk";
import { PostData } from "../../API/postApi";
import { RemoveIteminCart } from "../../API/OpportunityServices/OpprThunk";

const Header = ({ItemInputChange,show, itemSearchTerm}) =>{
    // const [itemSearchTerm, setItemSearchTerm] = useState("");
    const userData = useSelector(selectUser);
    const UserName = userData?.UserName;
    const CompanyName = userData?.CompanyName;
    const databaseName = userData?.DatabaseName;
    const jwtToken = userData?.JwtToken;
    const Navigate = useNavigate();
    const dispatch = useDispatch();
    const [userDropdown, setUserDropdown] = useState(false);
    const handleLogout = async () => {
        dispatch(logoutUser());
        dispatch(resetItemGroup());
        dispatch(resetItems());
        dispatch(setCustomerCode(""));
        Navigate('/');
    };
    const handleUserHeader = () => {
        setUserDropdown(true);
    }
    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, () => setUserDropdown(false));
return(
    <div className="header d-flex justify-content-between position-sticky  align-items-center">
        <div className=" headerLogo">
            <div className='logo-containerhead'>
                    <div className=' logo1head'>Tp tiles</div>
                    <div className='logo2head'>tp inspire</div>
                </div>
        </div>
        {show === "show" &&
          <div className="searchDiv">
              <input type="text" 
                  className="searchInput" 
                  placeholder="Search"
                  // value={CustomerValue ? (CustomerCode + '-' + customerName) : searchTerm}
                  value={itemSearchTerm}
                  onChange={ItemInputChange}
              />
                <span className="searchIconSpan"><SearchIcon/></span>
            </div>
            }
        <div>
            <div className="userheader" onClick={handleUserHeader}>
                <span>{UserName?.charAt(0)}</span>
            </div>
            {userDropdown && 
                <div className="userdropdown"
                    ref={wrapperRef}>
                    <p className="headerCompany">{CompanyName}</p>
                    <hr className="headerHr"/>
                    <p className="headerUsername">{UserName}</p>
                    <button className="logout" onClick={handleLogout}>Logout</button>
                </div>}
        </div>
    </div>
);
}

export default Header